<template>
    <div class="ConnaitreJobstream">
        <HeadPage :title="'JobStream'" 
                  :category="'Nous connaitre'"
                  :img="'nous-connaitre/jobstream.jpg'"
                  :imgAlt="'Jobstream head page'"
        />
        <ContentPage :content="content"
        />
    </div>
</template>

<script>
import HeadPage from '../global/HeadPage.vue'
import ContentPage from '../global/ContentPage.vue'

export default {
    name: "ConnaitreJobstream",
    data() {
        return {
            content: [
                { 
                    text: [ `<strong>JobStream</strong> est un <strong>cabinet de conseil en Ressources Humaines</strong> et un <strong>organisme de formation</strong> créé en 2017 par Gilles Vigné.
                    En septembre 2020, Pascal Philippe en a pris la direction et développe l'activité <strong>Formation Professionnelle Continue</strong> avec succès.
                    <strong>JobStream</strong> est composé de <strong>consultants experts</strong> en ressources humaines et de <strong>formateurs pour adultes. JobStream</strong> est une entité adossée
                    au <strong>Groupe Intérim & Placement</strong>, ce qui lui procure une <strong>dimension nationale</strong> et un fort ancrage
                    sur les territoires où il opère. Grâce à ses partenaires <strong>JobStream</strong> est positionné sur l'ensemble des enjeux adossés aux <strong>problématiques de parcours
                    professionnels et de gestion des compétences</strong> :`,
                    `<ul>
                        <li>Entretiens professionnels externalisés</li>
                        <li>Bilan de compétences</li>
                        <li>Formation aux compétences comportementales (Soft Skills)</li>
                        <li>Ingénierie Formation</li>
                        <li>Repositionnement professionnel</li>
                        <li>Recrutement, positionnement et évaluation</li>
                    </ul>`,
                    `Notre approche est guidée par le souci constant d'allier <strong>performance économique et responsabilité sociétale</strong> 
                    en misant sur des <strong>approches opérationnelles et inclusives.</strong>`
                        ]
                }
            ]
        }
    },
    components: {
        HeadPage,
        ContentPage
    }
}
</script>